const styles = theme => ({
  root: {
    display: "flex",
  },

  contactLeft: {
    width: "50%",
    paddingLeft: 30,
    paddingRight: 30,
    textAlign: "center",    
    "& .information": {
      marginBottom: 25,
      lineHeight: 2.0,
      fontWeight: 'bold',
      fontSize: "1.1em",
    },

    "& span a": {
      color: theme.colors.primary
    },
    "& .informationContact > div": {
      display: "flex",
      paddingBottom: 25,
      width: "100%",
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center',
    },

    "& .informationContact p": {
      backgroundColor: theme.colors.primary,
      padding: 10,
      marginBottom: 10,
      textTransform: "uppercase",
      color: "white",
      fontWeight: 'bold',
    },
    "& .informationContact textarea": {
      marginTop: 20,
      width: "100%",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      outline: "none",
    },

    "& .informationContact > div > div svg": {
      marginTop: 20,
      marginRight: 10,
      color: theme.colors.primary,
    }
  },
  contactRight: {
    width: "50%",
    padding: 8,
    position: 'relative',
  },
  // -------Map-----------------
  titleMap: {
    color: "red"
  },
  // ------mobile--------
  [theme.breakpoints.down('xs')]:{
    root: {
      display: "block"
    },
    contactLeft: {
      width: "100%"
    },
    contactRight: {
      width: "100%",
      height: 500
    }
  }
});

export default styles;